import React from "react";
import { useDispatch } from "react-redux";
import LogoImg from "src/assets/images/logo.svg";
import styles from "src/components/atoms/Logo/styles.module.css";
import { useRedirect } from "src/navigation/useRedirect";
import { setEventType } from "src/store/events/eventsSlice";
import { PAGES } from "src/types/navigation";

export const Logo: React.FC = () => {
  const dispatch = useDispatch();

  const { redirect } = useRedirect();
  const handleClickLogo = () => {
    dispatch(setEventType(undefined));

    redirect({ scheme: PAGES.ROOT });
    // Возврат к началу ленты: если пользователь уже на главной и прокрутил список
    // вниз, клик по лого поднимает его наверх (лента — в window-скролле, как ArrowTop).
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div className={styles.logoWrapper} role="button" onClick={handleClickLogo}>
      <img src={LogoImg} alt="logo" />
    </div>
  );
};
